import {
  AttackErrorAttribute,
  ChallengeAttribute,
  DetailType,
  DigAttribute,
  NeutralAttackAttribute,
  ReceptionAttribute,
  TechnicalErrorAttribute,
  VolleyballAttributeId,
  VolleyballCardsAttribute,
  VolleyballIncidentId,
  VolleyballRefereeChallengeAttribute,
} from '@collector/sportsapi-client-legacy'

import {
  SportAttributesConfiguration,
  SportDetailsConfiguration,
} from '../composables/useSportOptions/types'
import AttackErrorDetailsModal from './Modals/AttackErrorDetailsModal/AttackErrorDetailsModal.vue'
import { getIncidentDetailsFillState as attackErrorIncidentValidator } from './Modals/AttackErrorDetailsModal/utils'
import AttackPointDetailsModal from './Modals/AttackPointDetailsModal/AttackPointDetailsModal.vue'
import { getIncidentDetailsFillState as attackPointIncidentValidator } from './Modals/AttackPointDetailsModal/utils'
import BlockPointDetailsModal from './Modals/BlockPointDetailsModal/BlockPointDetailsModal.vue'
import { getIncidentDetailsFillState as blockPointIncidentValidator } from './Modals/BlockPointDetailsModal/utils'
import NeutralAttackDetailsModal from './Modals/NeutralAttackDetailsModal/NeutralAttackDetailsModal.vue'
import { getIncidentDetailsFillState as neutralAttackIncidentValidator } from './Modals/NeutralAttackDetailsModal/utils'

export enum VolleyballGroupName {
  Zone = 'Zone',
  ErrorType = 'Error type',
  ReceptionType = 'Reception type',
  DigType = 'Dig type',
  CardType = 'Card type',
  BlockedBack = 'Blocked back',
}

export const VolleyballDetailsConfiguration: SportDetailsConfiguration<
  VolleyballIncidentId,
  VolleyballAttributeId
> = {
  [VolleyballIncidentId.AttackPoint]: {
    component: AttackPointDetailsModal,
    getIncidentDetailsFillState: attackPointIncidentValidator,
  },
  [VolleyballIncidentId.AttackError]: {
    component: AttackErrorDetailsModal,
    getIncidentDetailsFillState: attackErrorIncidentValidator,
  },
  [VolleyballIncidentId.NeutralAttack]: {
    component: NeutralAttackDetailsModal,
    getIncidentDetailsFillState: neutralAttackIncidentValidator,
  },
  [VolleyballIncidentId.BlockPoint]: {
    component: BlockPointDetailsModal,
    getIncidentDetailsFillState: blockPointIncidentValidator,
  },
  [VolleyballIncidentId.TechnicalErrors]: [
    {
      name: VolleyballGroupName.ErrorType,
      cols: 2,
      attributes: [
        TechnicalErrorAttribute.RotationError,
        TechnicalErrorAttribute.FootFault,
        TechnicalErrorAttribute.NetTouch,
        TechnicalErrorAttribute.IllegalTouch,
      ],
      important: true,
      type: DetailType.Button,
    },
  ],
  [VolleyballIncidentId.Reception]: [
    {
      name: VolleyballGroupName.ReceptionType,
      cols: 2,
      attributes: [
        ReceptionAttribute.Perfect,
        ReceptionAttribute.Plus,
        ReceptionAttribute.Negative,
        ReceptionAttribute.Error,
      ],
      important: true,
      type: DetailType.Button,
    },
  ],
  [VolleyballIncidentId.Dig]: [
    {
      name: VolleyballGroupName.DigType,
      cols: 2,
      attributes: [DigAttribute.Spectacular, DigAttribute.FreeBall],
      important: false,
      type: DetailType.Button,
    },
  ],
  [VolleyballIncidentId.Cards]: [
    {
      name: VolleyballGroupName.CardType,
      cols: 2,
      attributes: [
        VolleyballCardsAttribute.YellowCard,
        VolleyballCardsAttribute.RedCard,
        VolleyballCardsAttribute.PlayerExpulsion,
        VolleyballCardsAttribute.PlayerDisqualification,
      ],
      important: true,
      multiple: true,
      type: DetailType.Button,
    },
  ],
}

export const VolleyballAttributesConfiguration: SportAttributesConfiguration<
  VolleyballIncidentId,
  VolleyballAttributeId
> = {
  [VolleyballIncidentId.AttackError]: [
    AttackErrorAttribute.OutAttack,
    AttackErrorAttribute.AntennaAttack,
    AttackErrorAttribute.NetAttack,
    AttackErrorAttribute.IllegalTouch,
  ],
  [VolleyballIncidentId.NeutralAttack]: [NeutralAttackAttribute.BlockedBack],
  [VolleyballIncidentId.TechnicalErrors]: [
    TechnicalErrorAttribute.RotationError,
    TechnicalErrorAttribute.FootFault,
    TechnicalErrorAttribute.NetTouch,
    TechnicalErrorAttribute.IllegalTouch,
  ],
  [VolleyballIncidentId.Reception]: [
    ReceptionAttribute.Perfect,
    ReceptionAttribute.Plus,
    ReceptionAttribute.Negative,
    ReceptionAttribute.Error,
  ],
  [VolleyballIncidentId.Dig]: [DigAttribute.Spectacular, DigAttribute.FreeBall],
  [VolleyballIncidentId.Challenge]: [
    ChallengeAttribute.Correct,
    ChallengeAttribute.Incorrect,
  ],
  [VolleyballIncidentId.RefereeChallenge]: [
    VolleyballRefereeChallengeAttribute.CallStands,
    VolleyballRefereeChallengeAttribute.CallOverturned,
  ],
  [VolleyballIncidentId.Cards]: [
    VolleyballCardsAttribute.YellowCard,
    VolleyballCardsAttribute.RedCard,
    VolleyballCardsAttribute.PlayerExpulsion,
    VolleyballCardsAttribute.PlayerDisqualification,
  ],
}
